<template>
  <div class="editProfile">
    <van-form
      ref="validateForm"
      validate-first
      input-align="right"
      :show-error="false"
      :show-error-message="false"
    >
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.name"
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.nickname"
        label="昵称"
        placeholder="请输入昵称"
      />
       <van-field
        label="性别"
        placeholder="请选择性别"
      >
        <template #input>
          <van-radio-group v-model="userInfo.gender" direction="horizontal">
            <van-radio :name="1">男</van-radio>
            <van-radio :name="2">女</van-radio>
            <van-radio :name="3">保密</van-radio>
          </van-radio-group>
        </template>
      </van-field>
           <van-field
        readonly
        clickable
        right-icon="arrow"
        :value="userInfo.birthday && userInfo.birthday.substring(0, 11)"
        label="生日"
        placeholder="请选择生日"
        @click="showBirthdayPicker = true"
      />
      <van-popup v-model="showBirthdayPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="请选择生日"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="birthdayOnConfirm"
          @cancel="showBirthdayPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="area"
        :value="value"
        label="所属省份"
        :rules="[{ required: true, message: '请选择所属省份' }]"
        placeholder="点击选择省"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :columns-num="1"
          :area-list="cityList"
          @confirm="onConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field
        v-model.trim="userInfo.idCardNo"
        label="身份证号"
        readonly
      >
        <template v-if="!userInfo.idCardNo" #button>
          <van-button size="small" type="primary" color="#1972ff" @click="toIdentify">前往身份认证</van-button>
        </template>
      </van-field>
      <p class="tipxd">* 认证通过后可以参与学习排名，优秀学员可获得奖励，并向省级主管单位发函表扬</p>
      <van-field
        readonly
        clickable
        required
        :label-width="120"
        right-icon="arrow"
        v-model="userInfo.userIdentity"
        label="运动员目前状态"
        placeholder="请选择运动员目前状态"
        :rules="[{ required: true, message: '请选择运动员目前状态' }]"
        @click="showuserIdentityPicker = true"
      />
      <van-popup v-model="showuserIdentityPicker" round position="bottom">
        <van-picker
          title="请选择运动员目前状态"
          show-toolbar
          :default-index="activeUserIdentityIndex"
          :columns="userIdentityLists"
          @cancel="showuserIdentityPicker = false"
          @confirm="userIdentityOnConfirm"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        required
        right-icon="arrow"
        v-model="userInfo.project"
        label="运动项目"
        placeholder="请选择运动项目"
        :rules="[{ required: true, message: '请选择运动项目' }]"
        @click="showProjectPicker = true"
      />
      <van-popup v-model="showProjectPicker" round position="bottom">
        <van-picker
          title="请选择运动项目"
          show-toolbar
          :default-index="activeProjectIndex"
          :columns="projectList"
          @cancel="showProjectPicker = false"
          @confirm="projectConfirm"
        />
      </van-popup>
      <div class="handle_btn">
        <van-button
          round
          block
          plain
          type="info"
          class="cancel_btn"
          @click="cancelHandle"
          >取消</van-button
        >
        <van-button round block type="info" class="save_btn" @click="saveHandle"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
const OSS = require("ali-oss");
import { idCardNoberValidator } from "@/utils/validate.js";
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[0-9]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
const isIdentitycard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
const isWorkPhone = /(^(\d{11})$|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/;
import {project} from './js/data'
export default {
  name: "editProfile",
  data() {
    return {
      firstFillInFlag: false, //登录完跳进来
      haveSavedDetailFlag: false, //判断资料是否完善
      showArea: false,
      cityList: {
        province_list: {},
        city_list: {},
        county_list: {},
      }, // 数据格
      areaList:[],
      value:'',
      userInfo: {
        name: "",
        idCardNo: "",
        gender: "",
        birthday: "",
        userIdentity: "",
        areaCode:"",
        project:'',
      },
      showBirthdayPicker: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2000, 0, 1),
      showNationPicker: false,
      showuserIdentityPicker: false,
      showProjectPicker:false,
      userIdentityLists: [
        {
          type: 1,
          text: "在役运动员"
        },
        {
          type: 2,
          text: "退役运动员"
        },
        {
          type: 3,
          text: "转型期运动员"
        },
        {
          type: 4,
          text: "体育院校在读"
        },
        {
          type: 5,
          text: "体育爱好者"
        },
        {
          type: 6,
          text: "非运动员"
        }
      ],
      projectList:[],
      activeNationIndex: 0,
      activeUserIdentityIndex: 0,
      activeProjectIndex:0,
    };
  },
  async created() {
    this.firstFillInFlag =
    this.$route.query && this.$route.query.type == "fillIn";
    console.log(project,'11111111111111111');
    if(project && project.length){
      this.projectList = project.map((item,index)=>{
        return {
          type:index,
          text:item
        }
      })
    }
    await this.getRegionList()
    if(localStorage.getItem('token')){
      this.getData();
    }
    
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.back, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.back, false); //false阻止默认事件
  },
  methods: {
    toIdentify(){
      this.$router.push('/idcard')
    },
     // 省市选择
    onConfirm(values) {
      console.log(values);
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.userInfo.areaCode = values[0].code;
      this.showArea = false;
    },
    //获取城市列表
    async getRegionList() {
      await this.$api.usercenter.getTree({ type: 1 }).then((res) => {
        if (res.success && res.data) {
          let filterArr = res.data.filter((item) => {
            return item.code.length === 2 && item.children;
          });
          this.areaList = res.data;
          let uniqueArr = Array.from(new Set(filterArr));
          // 切换成vant省市组件格式
          uniqueArr.map((item) => {
            this.cityList.province_list[item.code] = item.name;
            item.children.map((province) => {
              this.cityList.city_list[province.code] = province.name;
              (province.children || []).map((county) => {
                this.cityList.county_list[county.code] = county.name;
              });
            });
          });
        }
      });
    },
    treeFindPath(tree, func, path = []) {
      if (!tree) return [];
      for (const data of tree) {
          path.push({
            code:data.code,
            name:data.name
          });
          if (func(data)) return path;
          if (data.children) {
              const findChildren = this.treeFindPath(data.children, func, path);
              if (findChildren.length) return findChildren;
          }
          path.pop();
      }
      return [];
    },
    back() {
      console.log(this.haveSavedDetailFlag,'返回了反对法地方');
      if (!this.haveSavedDetailFlag) {
        this.$notify({
          duration: 3000,
          type: "danger",
          message: "请先完善个人必填信息"
        });
        if (window.history && window.history.pushState) {
          // 往历史记录里面添加一条新的当前页面的url
          history.pushState(null, null, document.URL);
          // 给 popstate 绑定一个方法 监听页面刷新
          window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
      } else {
        this.$router.go(-1);
      }
    },
    //获取详情
    getData() {
      this.$api.usercenter.findUser().then(res => {
        console.log(res);
        if (res.code == 0 && res.success) {
          if(res.data.areaCode && res.data.userIdentity){
            this.haveSavedDetailFlag = true;
          }else{
            this.haveSavedDetailFlag = false;
          }
          const arr  = this.treeFindPath(
              this.areaList,
              (data) => data.code == res.data.areaCode
          );
          this.value = arr
            .filter((item) => !!item)
            .map((item) => item.name)
            .join("/");
          // console.log(this.value);
          this.userInfo.areaCode = arr[0]?.name;
          this.userInfo = Object.assign({}, this.userInfo, res.data);
          this.userInfo.project = res.data.extra?.project;
          this.activeUserIdentityIndex = this.matchText(
            this.userIdentityLists,
            res.data.userIdentity
          ).index;

          this.currentDate = new Date(res.data.birthday);
        }
      });
    },
    //picker 选择框确定
    birthdayOnConfirm(date) {
      console.log(date);
      this.userInfo.birthday = this.formatime(date);
      this.showBirthdayPicker = false;
    },
    userIdentityOnConfirm(value, index) {
      this.userInfo.userIdentity = value.text;
      this.showuserIdentityPicker = false;
    },
    projectConfirm(value, index) {
      this.userInfo.project = value.text;
      this.showProjectPicker = false;
    },
    // 格式化时间
    formatime(dayCount) {
      const createtime = new Date(dayCount);
      const year = createtime.getFullYear();
      let month = createtime.getMonth() + 1;
      let day = createtime.getDate(); // 几号
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day + " 00:00:00";
    },
    mobileValidator(val) {
      return isPhone.test(val);
    },
    genderValidator(val) {
      return !!this.userInfo.gender;
    },
    //匹配内容
    matchText(data, resVal) {
      let result = {};
      data.forEach((item, index) => {
        if (item.type == resVal) {
          result.text = item.text;
          result.index = index;
        } else if (item.text == resVal) {
          result.index = index;
        } else if (item == resVal) {
          result.index = index;
        }
      });
      return result;
    },
    cancelHandle() {
      if (this.haveSavedDetailFlag) {
        if (this.firstFillInFlag) {
          this.$router.push("/homepage");
          return;
        }
        this.$router.push("/saccount");
      } else {
        this.$notify({
          duration: 3000,
          type: "danger",
          message: "请先完善个人必填信息"
        });
      }
    },
    //保存
    saveHandle() {
      this.$refs.validateForm
        .validate()
        .then(() => {
          this.$api.user.updateUser({
            nickname:this.userInfo.nickname,
            name: this.userInfo.name,
            idCardNo: this.userInfo.idCardNo,
            gender: this.userInfo.gender,
            birthday: this.userInfo.birthday,
            userIdentity:this.userInfo.userIdentity,
            areaCode:this.userInfo.areaCode,
          }).then(res => {
            if (res.code == 0 && res.success) {
              // this.$toast({
              //   message: "保存成功"
              // });
              // this.getData();
              // if (this.firstFillInFlag) {
              //   this.$router.push("/homepage");
              //   return;
              // }
              // this.$router.push("/saccount");
            }
          });
          this.$api.dynamicPages.userextension({
            extra:{
              project:this.userInfo.project
            }
          }).then(res => {
            if (res.code == 0 && res.success) {
              this.$toast({
                message: "保存成功"
              });
              this.getData();
              if (this.firstFillInFlag) {
                this.$router.push("/homepage");
                return;
              }
              this.$router.push("/saccount");
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.$toast({
            message: error[0].message,
            className: "errorTY"
          });
        });
    }
  }
};
</script>


<style lang="stylus" scoped>
.tipxd{
  font-size:13PX;
  padding:5PX 16PX;
  line-height:24PX;
  background:#fff;
  color:#ee0a24;
  opacity:.6;
  position:relative;
  &::after{
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
}
.editProfile {
  // height: 100vh;
  background: #f5f6fa;
  overflow: auto;

  .nav_bar {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }

  .zhihui {
    /deep/ .van-field__control {
      color: #c8c9cc;
    }
  }

  .space_nav_bar {
    background-color: transparent !important;
  }

  .photo_box {
    position: relative;
    width: 200px;
    height: 280px;
    border-radius: 10px;
    overflow: hidden;
  }

  .my_photo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
    }

    .tips {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 200px;
      height: 56px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .re_uploadImg {
      width: 112px;
      height: 28px;
    }
  }

  .file_box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .file {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .space {
    height: 16px;
    width: 100%;
  }

  .handle_btn {
    width: 750px;
    height: 112px;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px #EAEAEA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    .cancel_btn {
      width: 332px;
      height: 88px;
      border-radius: 50px;
      border: 1px solid #1972FF;
      margin-right: 26px;
      color: #1972FF;
      font-size: 32px;
    }

    .save_btn {
      width: 332px;
      height: 88px;
      background: #1972FF;
      border-radius: 50px;
      font-size: 32px;
      color: #FFFFFF;
    }
  }
}
</style>
<style lang="stylus">
.editProfile {
  .van-uploader__wrapper {
    width: 100%;
    height: 100%;

    .van-uploader__upload {
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }

  .van-cell {
    min-height: 2.773rem;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    display: flex;
    align-items: center;
  }

  .van-cell--required::before {
    left: 0.8rem;
  }

  .van-cell.photo_wrap {
    align-items: flex-start;
    padding-top: 0.96rem;
    padding-bottom: 1.066rem;
  }

  .van-cell.block_field {
    display: block;
    padding-top: 0.8rem;
    padding-bottom: 0.9rem;

    .radio_group {
      margin-top: 0.9rem;
    }
  }
}

.van-toast.errorTY {
  background-color: #FF5758 !important;
}
</style>